import { FEATURES, type FeatureKey } from "./features"

export interface DeckItem {
  title: string
  slug: string
  path: string
  description: string
  audience: string
  icon: string
  estimatedMinutes: number
  feature?: FeatureKey
  // Alternate content served when the Mining feature is off ("vanilla"
  // deploys) — same slug/URL, token-focused markdown.
  vanillaPath?: string
  vanillaDescription?: string
}

// WARNING: keep this a plain data-only array literal (string/number fields only).
// scripts/generate-static-docs.js extracts and evals it at build time —
// computed expressions or references inside the array would break the build.
export const decks: DeckItem[] = [
  {
    title: "WELEPHANT in 5 Minutes",
    slug: "quick",
    path: "/assets/decks/quick.md",
    description: "A quick overview for anyone — play, stake, compound.",
    audience: "Everyone",
    icon: "/assets/images/welephant.svg",
    estimatedMinutes: 3,
    vanillaPath: "/assets/decks/quick-vanilla.md",
    vanillaDescription: "A quick overview for anyone — swap, stake, bridge.",
  },
  {
    title: "The Miner's Playbook",
    slug: "miner",
    path: "/assets/decks/miner.md",
    description: "Strategies for active Prediction Mining players.",
    audience: "Active Players",
    icon: "/assets/images/elephant.svg",
    estimatedMinutes: 5,
    feature: "mining",
  },
  {
    title: "Liquid Staking for Investors",
    slug: "investor",
    path: "/assets/decks/investor.md",
    description: "ERC-4626 vault, yield sources, and risk profile.",
    audience: "Investors",
    icon: "/assets/images/stwelephant.svg",
    estimatedMinutes: 4,
  },
]

// Decks visible under the current feature flags, with vanilla content
// substituted when Mining is off.
export const visibleDecks = decks
  .filter((d) => !d.feature || FEATURES[d.feature])
  .map((d) =>
    !FEATURES.mining && d.vanillaPath
      ? { ...d, path: d.vanillaPath, description: d.vanillaDescription ?? d.description }
      : d
  )

export function getDeckBySlug(slug: string): DeckItem | undefined {
  return visibleDecks.find((d) => d.slug === slug)
}
